import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className="hero-text">
          <div className="hello-badge">
            <span role="img" aria-label="wave">👋</span> 你好！
          </div>
          <h1>我是<span className="highlight">Yoji</span>，<br />一个解决问题<br />和讲故事的人</h1>
          <div className="hero-buttons">
            <Link to="/about" className="about-button">关于我 <span>→</span></Link>
            <Link to="/contact" className="contact-button">联系我</Link>
          </div>
        </div>
        
        <div className="hero-image">
          <img src="/images/yoji-profile.png" alt="Yoji的个人照片" />
          <div className="badge tech-badge">
            <span role="img" aria-label="tech">💻</span> 技术
          </div>
          <div className="badge design-badge">
            <span role="img" aria-label="design">🎨</span> 设计
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 